/**
 * @Description: 接口域名常量
 * @author zhaijiayu
 * @date 2021/8/17
*/
import config from '../config/index'

let UPLOAD = `https://api.${config.baseUrl}`
let RESOURCE = `https://resource.${config.baseUrl}`
let USER = `https://user.${config.baseUrl}`
let CREATOR = `https://creator.${config.baseUrl}`
let CLOUD = `https://cloud.${config.baseUrl}`
let NEWS = `https://news.${config.baseUrl}`
let COS = `https://obs.${config.baseUrl}`
let ACTIVITY = `https://activity-api.${config.baseUrl}`
let SWNEWS = `https://swnews.${config.baseUrl}`
let SWUSER = `https://swuser.${config.baseUrl}`
let MEDIA = `https://${process.env.API_ENV == "online" ? "api.media.dingxinwen.cn" : "nm.dingnews.net"}`
let BI = `https://bdcollect.${process.env.API_ENV == "online" ? "dingxinwen.cn" : "dingnews.net"}`
let OLDBI = `https://bi.${config.baseUrl}`
let RECRUIT = `https://recruit.${config.baseUrl}`
let COMMON = `https://common.${process.env.API_ENV == "online" ? "dingxinwen.cn" : "dingnews.net"}`
let TOPNEWS = `https://topnews.${process.env.API_ENV == "online" ? "dingxinwen.cn" : "dingnews.net"}`
let HSUPLOAD = `https://upload.${process.env.API_ENV == "online" ? "dingxinwen.cn" : "dingnews.net"}`
let AI = `https://openai.${process.env.API_ENV == "online" ? "dingxinwen.cn" : "dingxinwen.cn"}`
let ROBOT = `https://robot-api.${process.env.API_ENV == "online" ? "dingxinwen.cn" : "dingnews.net"}`

export const UPLOAD_HOST = UPLOAD
export const RESOURCE_HOST = RESOURCE
export const USER_HOST = USER
export const CREATOR_HOST = CREATOR
export const CLOUD_HOST = CLOUD
export const NEWS_HOST = NEWS
export const COS_HOST = COS
export const ACTIVITY_HOST = ACTIVITY
export const SWNEWS_HOST = SWNEWS
export const SWUSER_HOST = SWUSER
export const MEDIA_HOST = MEDIA
export const BI_HOST = BI
export const OLDBI_HOST = OLDBI
export const RECRUIT_HOST = RECRUIT
export const COMMON_HOST = COMMON
export const TOPNEWS_HOST = TOPNEWS
export const HSUPLOAD_HOST = HSUPLOAD
export const AI_HOST = AI
export const ROBOT_HOST = ROBOT

export default {
    NEWS_HOST,
    CLOUD_HOST,
    UPLOAD_HOST,
    USER_HOST,
    RESOURCE_HOST,
    CREATOR_HOST,
    COS_HOST,
    ACTIVITY_HOST,
    SWNEWS_HOST,
    SWUSER_HOST,
    MEDIA_HOST,
    BI_HOST,
    OLDBI_HOST,
    RECRUIT_HOST,
    COMMON_HOST,
    TOPNEWS_HOST,
    HSUPLOAD_HOST,
    AI_HOST,
    ROBOT_HOST
}